
export default ({ showType, closeType }) => {
  const INITIAL_STATE = {
    areVisible: false
  };

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case closeType:
        return {
          ...state,
          areVisible: false
        };

      case showType:
        return {
          ...state,
          areVisible: true
        };

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/emojisMaker.js
 **/